export default __webpack_public_path__ + "static/media/white copy.5b46c884.png";